<template>
  <div id="app">
    <FfjbNavbar />
    <router-view />
    <FfjbFooter />
  </div>
</template>

<script>
import FfjbNavbar from './components/FfjbNavbar.vue';
import FfjbFooter from './components/FfjbFooter.vue';

export default {
  name: 'AppMain',
  components: {
    FfjbNavbar,
    FfjbFooter
  }
};
</script>

<style>
body {
  margin: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background-color: #f4f4f4;
  color: #333;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
</style>